export class ServicePackageOrderFilter {
  boatId: number;
  customerId: number;
  packageServiceId: number;
  startDate: Date;
  endDate: Date;
  marinaId: number;
  page: number;
  size: number;
  order: string;
  packageStatus: string[];

  constructor() {
    this.boatId = null;
    this.customerId = null;
    this.packageServiceId = null;
    this.startDate = null;
    this.endDate = null;
    this.marinaId = null;
    this.page = 0;
    this.size = 10;
    this.order = 'ASC';
    this.packageStatus = [];
  }
}